import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const TransactionDateRangePickerStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      color: "#545454",
      fontSize: "16px",
      fontWeight: theme.typography.fontWeightMedium,
      paddingLeft: "28px",
    },
    button: {
      padding: "0px 25px 25px 25px",
    },
    dialogContent: {
      padding: "25px 20px 0px 20px",
      justifyContent: "center",
      minHeight: "400px",
      [theme.breakpoints.down("md")]: {
        padding: "5px",
      },
    },
    dateRangeWrapper: {
      width: "100%",
    },
    datesButton: {
      border: "1px solid #A3A3A3",
      color: "#545454",
      fontSize: "16px",
      fontWeight: 400,
      borderRadius: "6px",
      height: "48px",
      textTransform: "none",
      padding: "0px",
    },
  }),
);
